export default __webpack_public_path__ + "static/media/coderbyte_logo_1.d71a3504.png";